import React from 'react';
import { Link } from 'react-router-dom';

const index = () => {
  return (
    <footer>
      <div className="container-fluid px-0 py-3">
        <div className="row">
          <div className="col-lg-6">
            <p className="mb-3 mb-lg-0 text-center text-lg-start">
              © Castle Software, Inc. 2001-{new Date().getFullYear()}
            </p>
          </div>
          <div className="col-lg-6">
            <p className="mb-0 text-center text-lg-end">
              <Link
                to="https://www.castlelearning.com/terms-of-use/"
                key="termsOfServiceKey"
                target="_blank">
                Terms of Service
              </Link> 
              {' | '} 
              <Link
                to="https://www.castlelearning.com/privacy-policy/"
                key="policyLinkKey"
                target="_blank">
                Privacy Policy
              </Link> | 7
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default index;
